const langtrans={
      lxjfs:["联系方式","Contacts"],
      ddjxzb:["大救星总部","Dajiuxing Headquarter "],
      ddzbjs:["地址：北京市门头沟区石龙经济开发区莲石湖西路98号9号楼","Address:Building 98, No.9, Lianshihu West Road, Mentougou District Beijing 102300, China"],
      dh:["电话：","Tel:"],
      bxdcsw:["保险单位合作","Cooperation with insuarance companies"],
      yx:["邮箱：","Email:"],
      ffwsjm:["服务商加盟","Becoming a service provider"],
      lmmjs:["联盟介绍","Introduction of JTGAA "],
      sqjmm:["申请加盟","Apply to join"],
      xsssq:["星使申请","Becoming a Xingshi"],
      cwwxss:["成为星使","Apply here"],
      bajyqz:["报案救援求助","Call for assistance"],
      yjxjyf:["意见建议反馈","Making a comment or feedback"],
      yjxfk:["意见反馈","Comment"],
      jyjgdl:["救援机构登录成功","en_translated"],
      jjgjgd:["监管机构登录成功","en_translated"],
      zzzhzz:["指挥中心登录成功","en_translated"],
      dlsbgy:["登录失败，该用户不属于监管机构","en_translated"],
      dlsbyh:["登录失败，用户名或密码错误","Your login failed for incorrect user name or password"],
      dlsbwz:["登录失败，未知错误","Your login failed for unknown reason"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/assets/languagejs/contact.vue.trans.js